import React from "react";
import styled, { keyframes, css } from "styled-components";

const loading = keyframes`
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
`;

const Skeleton = styled.div.withConfig({
  shouldForwardProp: (prop) => !['borderRadius', 'variant'].includes(prop)
})`
  background: linear-gradient(90deg, #e0e0e0 25%, #f5f5f5 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: ${loading} 1.5s infinite linear;
  border-radius: ${({ $borderRadius }) => $borderRadius || "4px"};
  display: ${({ display }) => display || "inline-block"};
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "20px"};
  margin: ${({ margin }) => margin || "0"};

  ${({ $variant }) =>
    $variant === "circle" &&
    css`
      border-radius: 50%;
    `}

  ${({ $variant }) =>
    $variant === "image" &&
    css`
      background: #ddd;
    `}
`;

const SkeletonLoader = ({
  active,
  width = "100%",
  height = "20px",
  variant = "square",
  borderRadius,
  margin,
  display,
  children
}) => {
  if (!active) return children;

  return (
    <Skeleton
      width={width}
      height={height}
      $variant={variant}
      $borderRadius={borderRadius}
      margin={margin}
      display={display}
    />
  );
};

export default SkeletonLoader;